/**
 * Cookie helpers for the visitor identity cookie (§5.8).
 *
 * - Name: tashimoto_support_visitor
 * - Value: opaque cookie_id issued by the server (uuid v4)
 * - Attributes: Path=/; Max-Age=31536000; SameSite=Lax; Secure on https.
 * - No HttpOnly — the widget JS must read it.
 * - Scoped to the embedding origin, not the API domain.
 */

export const COOKIE_NAME = 'tashimoto_support_visitor';
export const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

export function readVisitorCookie(): string | null {
  if (typeof document === 'undefined' || !document.cookie) return null;
  const parts = document.cookie.split(';');
  for (const p of parts) {
    const [rawName, ...rest] = p.split('=');
    if (rawName && rawName.trim() === COOKIE_NAME) {
      return decodeURIComponent(rest.join('=').trim());
    }
  }
  return null;
}

export function writeVisitorCookie(cookieId: string): void {
  if (typeof document === 'undefined') return;
  const isHttps =
    typeof location !== 'undefined' && location.protocol === 'https:';
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(cookieId)}`,
    'Path=/',
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
  ];
  if (isHttps) parts.push('Secure');
  document.cookie = parts.join('; ');
}

export function clearVisitorCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
}
